import get from 'lodash/get'

function getEnvironmentVariable(variableName: string, defaultValue: string | null = null) {
  const windowEnv = typeof window !== 'undefined' && window.env
  const processEnv = process.env
  const variableFromWindowEnv = get(windowEnv, variableName)
  const variableFromProcessEnv = get(processEnv, variableName)
  return variableFromWindowEnv || variableFromProcessEnv || defaultValue
}

export enum ENV_VARIABLES {
  API_BASE_URL = 'API_BASE_URL',
  PUBLIC_PATH = 'PUBLIC_PATH',
  SENTRY_DSN = 'SENTRY_DSN',
  ENV = 'ENV',
  ASSETS_PATH = 'ASSETS_PATH',
  POSTHOG_INTERNAL_CLINIC_API_KEY = 'POSTHOG_INTERNAL_CLINIC_API_KEY',
  POSTHOG_EXTERNAL_CLINIC_API_KEY = 'POSTHOG_EXTERNAL_CLINIC_API_KEY',
  POSTHOG_API_HOST = 'POSTHOG_API_HOST',
}

const getEnv = (envName: ENV_VARIABLES) => {
  const key = `REACT_APP_${envName}`
  if (envName === 'PUBLIC_PATH') {
    getEnvironmentVariable(key, 'http://localhost:3000')
  }
  return getEnvironmentVariable(key)
}

export const isProduction = () => getEnv(ENV_VARIABLES.ENV) === 'production'

export default getEnv
